import { NewElementOutDto, NewElementInDto } from '../../../types/element.dto'

export const NEW_ELEMENT = 'NEW_ELEMENT'
export const NEW_ELEMENT_SUCCESS = 'NEW_ELEMENT_SUCCESS'
export const NEW_ELEMENT_ERROR = 'NEW_ELEMENT_ERROR'
export const RESET_NEW_ELEMENT = 'RESET_NEW_ELEMENT'

export interface NewElement<T> {
  type: typeof NEW_ELEMENT
  payload: NewElementOutDto<T>
}

export interface NewElementSuccess<T> {
  type: typeof NEW_ELEMENT_SUCCESS
  payload: NewElementInDto<T>
}

export interface NewElementError {
  type: typeof NEW_ELEMENT_ERROR
  payload: string | boolean
}

export interface ResetNewElement {
  type: typeof RESET_NEW_ELEMENT
  payload: null
}

export interface State<T> {
  data: NewElementInDto<T> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

// Define una función que acepte un parámetro T y devuelva un initialState con ese tipo T
const createInitialState = <T>(): State<T> => {
  return {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  };
};

// Ahora puedes usar esta función para inicializar el estado con el tipo T que necesites
export const initialState = createInitialState<any>();

export type Actions<T> = NewElement<T> | NewElementSuccess<T> | NewElementError | ResetNewElement
